import { stringify } from 'querystring';

export class WP {
    constructor(event) {
        this.event = event;
    }

    trackEvent({
        productId,
        productName,
        price,
        colorSeo,
        shopName,
        brandName,
        categoryName,
        mainCategoryName,
        priceIntervalTypeName,
        rate,
        ducid
    }) {
        if (!DM.Utils.getCookie(DM.Cookies.KillTrackers) && !DM.Utils.killTracker('wpdot')) {
            window.WP.push(() => {
                window.WP.gdpr.runAfterConsent(() => {
                    if (window.WP.gdpr.check('mr', 'GWP')) {
                        const script = window.document.createElement('script');

                        const product = {
                            product: productId,
                            price: price,
                            quantity: 1
                        };

                        const params = {
                            kolor: colorSeo,
                            nazwa: productName,
                            sklep: shopName,
                            marka: brandName,
                            kategoria: categoryName,
                            cena: price,
                            persona: mainCategoryName,
                            poziom_cenowy: priceIntervalTypeName,
                            m_value: rate,
                            ducid: ducid
                        };

                        const requestParams = {
                            gwpClientId: 'domodi',
                            gwpAction: this.event,
                            gwpProducts: JSON.stringify([product]),
                            gwpExtParams: JSON.stringify(Object.keys(params).map(key => ({ name: key, value: params[key] }))),
                            gwpReferer: escape(new String(window.location).substring(0, 250)),
                            tt: Math.round(Math.random() * 1E10)
                        };

                        script.async = true;
                        script.src = `//px.wp.pl/exdotdynamic/?${stringify(requestParams)}`;
                        window.document.head.appendChild(script);
                        script.addEventListener('load', () => script.parentNode.removeChild(script));
                    }
                });
            });
        }
    }
}
